module.exports = __webpack_public_path__ + "static/media/mplayer_1_14.ed797f85.ico";